module.exports = __webpack_public_path__ + "img/warrning_icon_1.5dd4a353.png";